module.exports = __webpack_public_path__ + "img/manageStateNo.70524923.png";